import {isMobile} from "react-device-detect";
import {QuestionStatisticsType, RatingDistributionType, RatingStatisticsType} from "../definitions/types";
import {catalogName} from "./helpers";
import {ImageModel} from "../models/domain/imageModel";

export const isDevelopmentBuild = process.env.NODE_ENV?.toLowerCase() === "development";

export const windowBreakpoint = 768;

export const questionConnectionPageSize = 5;

export const bucket = isDevelopmentBuild ? 3 : 7;

export const isPreProd = window.location.hostname.toLowerCase().endsWith(".stage.awsprod.d2gstores.com") || window.location.hostname.toLowerCase().endsWith(".extstage.awsprod.d2gstores.com")

// Construct the URL for the current environment
export const url = [location.protocol, '//', isDevelopmentBuild || isPreProd ? `www.${catalogName}.com` : location.host, location.pathname].join('').toLowerCase();

export const reviewMediaDefaultPageSize = isMobile ? 32 : 5;

export const defaultRatingStatistics: RatingStatisticsType = {
    count: 0,
    sum: 0,
    min: 0,
    max: 0,
    range: 0,
    mean: 0,
    median: 0,
    mode: 0,
    standardDeviation: 0,
    distribution: {
        oneStar: 0,
        twoStar: 0,
        threeStar: 0,
        fourStar: 0,
        fiveStar: 0,
    } as RatingDistributionType
};

export const defaultQuestionStatistics: QuestionStatisticsType = {
    count: 0,
    answeredCount: 0,
    unansweredCount: 0
};

export const defaultFourBeeImageSource = 'https://static.commerceplatform.services/content/img/noimage.4b.jpg';

export const defaultDotFourB: ImageModel = new ImageModel({
    alt: 'No Image',
    description: 'No Image Available',
    filename: 'noimage.4b.jpg',
    width: 155,
    height: 200,
    isRaw: false,
    isWide: false,
    title: 'No Image Available',
    type: '.4b',
    url: defaultFourBeeImageSource
});

export const GALLERY_IDENTITY = '#media-gallery';